"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import Pristine from "pristinejs";

const defaultOptions = {
    classTo: 'form-group',
    errorClass: 'has-error',
    successClass: 'has-success',
    errorTextParent: 'form-group',
    // type of element to create for the error text
    errorTextTag: 'div',
    // class of the error text element
    errorTextClass: 'form-errors invalid-feedback'
};

const defaultSelectors = {
    base: '.js-form-validation'
};

let pristineForms = [];

export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createFormValidation(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createFormValidation(form, options = defaultOptions, selectors) {

    const pristine = new Pristine(form, options);

    form.addEventListener('submit', function (e) {
        // check if the form is valid
        if (!pristine.validate(form.querySelectorAll('input:not([type="hidden"]), select'))){
            e.preventDefault();
        }
    });

    pristineForms.push(pristine);
    return pristine;
}
export function updatePristine(form) {
    let pristine = pristineForms.filter((object) => {
        return object.form === form;
    });

    pristine[0].reset(); // resets errors
    pristine[0].destroy(); // clean up

    createFormValidation(form)
}

